<template>
  <div
    class="input"
    :class="{
      error: vErrors.length > 0 || isError,
      'with-information': withInformation,
      'password-show-state': passwordShow,
      centered,
      [`input--${mode}`]: true,
      concentration: concentration,
    }"
    v-click-outside="emitFocusOut"
  >
    <div class="input__wrapper" v-if="windowWidth > 999">
      <div class="input__title" v-if="mode !== 'small'">
        {{ translatedTitle }}
        <div class="input__information" v-if="withInformation">
          <VTooltip
            class="input__information"
						:triggers="['hover']"
						:distance="10"
            placement="right"
          >
            <div class="input__information-icon">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="9" cy="9.5" r="9" fill="#DBE7FD" />
                <path
                  d="M9.72815 11.8433H8.27183V11.0033C8.27183 10.6362 8.31049 10.3654 8.38782 10.191C8.47373 10.0074 8.65416 9.76871 8.9291 9.47496L9.86992 8.46982C10.0675 8.24033 10.1663 7.95577 10.1663 7.61613C10.1663 7.27649 10.0632 6.99652 9.85703 6.77622C9.65082 6.54673 9.38447 6.43199 9.05798 6.43199C8.73149 6.43199 8.45655 6.54214 8.23316 6.76245C8.01837 6.97357 7.89378 7.25814 7.85942 7.61613H6.29999C6.38591 6.79917 6.68233 6.1612 7.18925 5.70223C7.70476 5.23408 8.34486 5 9.10953 5C9.87421 5 10.4971 5.2249 10.9783 5.67469C11.4594 6.1153 11.7 6.73491 11.7 7.53352C11.7 8.08428 11.5582 8.54325 11.2747 8.91043C11.1114 9.13074 10.9869 9.28679 10.9009 9.37858C10.815 9.47038 10.699 9.58971 10.553 9.73658C10.4155 9.87427 10.2952 9.99819 10.1921 10.1083C10.0976 10.2093 10.0203 10.2965 9.96013 10.37C9.80548 10.5719 9.72815 10.8565 9.72815 11.2236V11.8433ZM9.01932 14.9C8.75297 14.9 8.52099 14.8036 8.32338 14.6108C8.12576 14.4089 8.02696 14.1702 8.02696 13.8949C8.02696 13.6103 8.12147 13.367 8.31049 13.1651C8.5081 12.9631 8.74008 12.8622 9.00643 12.8622C9.28137 12.8622 9.51765 12.9631 9.71526 13.1651C9.91288 13.3579 10.0117 13.5965 10.0117 13.8811C10.0117 14.1565 9.91288 14.3951 9.71526 14.5971C9.52624 14.799 9.29426 14.9 9.01932 14.9Z"
                  fill="white"
                />
              </svg>
            </div>
            <template v-slot:popper>
              <slot name="information"></slot>
            </template>
          </VTooltip>
        </div>
      </div>
      <input
        :type="currentType"
        class="input__el"
        :title="title"
        :disabled="disabled"
        v-model="text"
        @input="processInput"
        @focus="processFocus"
        @blur="processBlur"
        @keypress.enter="emitEnter"
        v-if="!mask"
        ref="inputEl"
        :placeholder="translatedPlaceholder"
      />
      <input
        :type="currentType"
        class="input__el"
        :title="title"
        :disabled="disabled"
        v-model="text"
        @input="processInput"
        @focus="processFocus"
        @blur="processBlur"
        @keypress.enter="emitEnter"
        v-mask="mask"
        v-else
        ref="inputEl"
        :placeholder="translatedPlaceholder"
      />
      <div
        class="password-show"
        @click="togglePasswordShow"
        v-if="passwordShow"
      >
        <svg
          width="20"
          height="21"
          viewBox="0 0 20 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          v-if="currentType === 'text'"
        >
          <line
            x1="1"
            y1="-1"
            x2="16.0602"
            y2="-1"
            transform="matrix(0.622274 0.782799 -0.790552 0.612394 4.99268 3.78101)"
            stroke="#B9C4D8"
            stroke-width="2"
            stroke-linecap="round"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.07095 6.32275C3.61622 7.24294 2.44355 8.38117 1.76311 9.23496C1.45791 9.62248 1.29075 10.0422 1.27979 10.4584C1.29079 10.8746 1.45791 11.2944 1.76311 11.6818C3.11535 13.3789 6.40771 16.1983 9.99827 16.1983C10.8792 16.1983 11.7422 16.0286 12.5629 15.7474L11.0813 13.8836C10.7392 13.989 10.3754 14.0458 9.99827 14.0458C7.99239 14.0458 6.36407 12.4386 6.36407 10.4584C6.36407 9.78076 6.55474 9.14681 6.88597 8.60598L5.07095 6.32275ZM7.89787 9.87893C7.84567 10.0633 7.81775 10.2577 7.81775 10.4584C7.81775 11.6461 8.79511 12.6109 9.99827 12.6109C10.0218 12.6109 10.0453 12.6105 10.0687 12.6098L7.89787 9.87893ZM12.7567 12.7931C13.3025 12.1655 13.6324 11.3497 13.6324 10.4584C13.6324 8.47813 12.0041 6.87089 9.99827 6.87089C9.40756 6.87089 8.84959 7.01028 8.35631 7.25753L6.86731 5.38443C7.85463 4.97688 8.91471 4.71838 10.0018 4.71838C13.5889 4.71838 16.8812 7.53825 18.2334 9.23496C18.5421 9.62248 18.7093 10.0422 18.7203 10.4584C18.7093 10.8746 18.5421 11.2943 18.2334 11.6818C17.4766 12.6316 16.112 13.9331 14.4276 14.895L12.7567 12.7931ZM11.8294 11.6266L11.1837 10.8143C11.2123 10.8162 11.2411 10.8172 11.2702 10.8172C11.6266 10.8172 11.946 10.6737 12.1788 10.4405V10.4584C12.1788 10.8888 12.0504 11.29 11.8294 11.6266ZM10.017 9.34661L9.28387 8.42437C9.50774 8.34763 9.74812 8.30593 9.99827 8.30593C10.2527 8.30593 10.4962 8.34898 10.7215 8.42783C10.3585 8.59926 10.0885 8.9405 10.017 9.34661Z"
            fill="#B9C4D8"
          />
        </svg>
        <svg
          width="18"
          height="13"
          viewBox="0 0 18 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          v-else-if="currentType === 'password'"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.81799 6.44754C6.81799 7.6352 7.79535 8.60005 8.99851 8.60005C10.2016 8.60005 11.179 7.6352 11.179 6.44754V6.42965C10.9463 6.66282 10.6268 6.80631 10.2704 6.80631C9.56887 6.80631 8.99851 6.24308 8.99851 5.55069C8.99851 5.05214 9.29623 4.61791 9.72171 4.41696C9.49647 4.33811 9.25299 4.29507 8.99851 4.29507C7.79535 4.29503 6.81799 5.25999 6.81799 6.44754ZM17.2336 5.2241C15.8815 3.52738 12.5891 0.70752 9.00203 0.70752C5.41155 0.70752 2.11555 3.52742 0.763349 5.2241C0.458149 5.61162 0.290989 6.03136 0.280029 6.44754C0.291029 6.86376 0.458149 7.2835 0.763349 7.67094C2.11559 9.36801 5.40795 12.1875 8.99851 12.1875C12.5891 12.1875 15.8815 9.36801 17.2336 7.67094C17.5424 7.28346 17.7096 6.86376 17.7206 6.44754C17.7096 6.03136 17.5424 5.61162 17.2336 5.2241ZM8.99851 10.035C6.99263 10.035 5.36431 8.42777 5.36431 6.44754C5.36431 4.46727 6.99263 2.86003 8.99851 2.86003C11.0044 2.86003 12.6327 4.46727 12.6327 6.44754C12.6326 8.42773 11.0043 10.035 8.99851 10.035Z"
            fill="#B9C4D8"
          />
        </svg>
      </div>
    </div>

    <div class="input__wrapper" v-else>
      <div class="input__title" v-if="title" @click="toggleTitle">
        {{ truncatedTitle ? truncatedTitle : translatedTitle }}
      </div>
      <input
        :type="currentType"
        class="input__el"
        :title="title"
        :disabled="disabled"
        v-model="text"
        @input="processInput"
        @focus="processFocus"
        @blur="processBlur"
        @keypress.enter="emitEnter"
        v-if="!mask"
        ref="inputEl"
        :placeholder="translatedPlaceholder"
      />
      <input
        :type="currentType"
        class="input__el"
        :title="title"
        :disabled="disabled"
        v-model="text"
        @input="processInput"
        @focus="processFocus"
        @blur="processBlur"
        @keypress.enter="emitEnter"
        v-mask="mask"
        v-else
        ref="inputEl"
        :placeholder="translatedPlaceholder"
      />
      <div
        class="password-show"
        @click="togglePasswordShow"
        v-if="passwordShow"
      >
        <svg
          width="20"
          height="21"
          viewBox="0 0 20 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          v-if="currentType === 'text'"
        >
          <line
            x1="1"
            y1="-1"
            x2="16.0602"
            y2="-1"
            transform="matrix(0.622274 0.782799 -0.790552 0.612394 4.99268 3.78101)"
            stroke="#B9C4D8"
            stroke-width="2"
            stroke-linecap="round"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.07095 6.32275C3.61622 7.24294 2.44355 8.38117 1.76311 9.23496C1.45791 9.62248 1.29075 10.0422 1.27979 10.4584C1.29079 10.8746 1.45791 11.2944 1.76311 11.6818C3.11535 13.3789 6.40771 16.1983 9.99827 16.1983C10.8792 16.1983 11.7422 16.0286 12.5629 15.7474L11.0813 13.8836C10.7392 13.989 10.3754 14.0458 9.99827 14.0458C7.99239 14.0458 6.36407 12.4386 6.36407 10.4584C6.36407 9.78076 6.55474 9.14681 6.88597 8.60598L5.07095 6.32275ZM7.89787 9.87893C7.84567 10.0633 7.81775 10.2577 7.81775 10.4584C7.81775 11.6461 8.79511 12.6109 9.99827 12.6109C10.0218 12.6109 10.0453 12.6105 10.0687 12.6098L7.89787 9.87893ZM12.7567 12.7931C13.3025 12.1655 13.6324 11.3497 13.6324 10.4584C13.6324 8.47813 12.0041 6.87089 9.99827 6.87089C9.40756 6.87089 8.84959 7.01028 8.35631 7.25753L6.86731 5.38443C7.85463 4.97688 8.91471 4.71838 10.0018 4.71838C13.5889 4.71838 16.8812 7.53825 18.2334 9.23496C18.5421 9.62248 18.7093 10.0422 18.7203 10.4584C18.7093 10.8746 18.5421 11.2943 18.2334 11.6818C17.4766 12.6316 16.112 13.9331 14.4276 14.895L12.7567 12.7931ZM11.8294 11.6266L11.1837 10.8143C11.2123 10.8162 11.2411 10.8172 11.2702 10.8172C11.6266 10.8172 11.946 10.6737 12.1788 10.4405V10.4584C12.1788 10.8888 12.0504 11.29 11.8294 11.6266ZM10.017 9.34661L9.28387 8.42437C9.50774 8.34763 9.74812 8.30593 9.99827 8.30593C10.2527 8.30593 10.4962 8.34898 10.7215 8.42783C10.3585 8.59926 10.0885 8.9405 10.017 9.34661Z"
            fill="#B9C4D8"
          />
        </svg>
        <svg
          width="18"
          height="13"
          viewBox="0 0 18 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          v-else-if="currentType === 'password'"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.81799 6.44754C6.81799 7.6352 7.79535 8.60005 8.99851 8.60005C10.2016 8.60005 11.179 7.6352 11.179 6.44754V6.42965C10.9463 6.66282 10.6268 6.80631 10.2704 6.80631C9.56887 6.80631 8.99851 6.24308 8.99851 5.55069C8.99851 5.05214 9.29623 4.61791 9.72171 4.41696C9.49647 4.33811 9.25299 4.29507 8.99851 4.29507C7.79535 4.29503 6.81799 5.25999 6.81799 6.44754ZM17.2336 5.2241C15.8815 3.52738 12.5891 0.70752 9.00203 0.70752C5.41155 0.70752 2.11555 3.52742 0.763349 5.2241C0.458149 5.61162 0.290989 6.03136 0.280029 6.44754C0.291029 6.86376 0.458149 7.2835 0.763349 7.67094C2.11559 9.36801 5.40795 12.1875 8.99851 12.1875C12.5891 12.1875 15.8815 9.36801 17.2336 7.67094C17.5424 7.28346 17.7096 6.86376 17.7206 6.44754C17.7096 6.03136 17.5424 5.61162 17.2336 5.2241ZM8.99851 10.035C6.99263 10.035 5.36431 8.42777 5.36431 6.44754C5.36431 4.46727 6.99263 2.86003 8.99851 2.86003C11.0044 2.86003 12.6327 4.46727 12.6327 6.44754C12.6326 8.42773 11.0043 10.035 8.99851 10.035Z"
            fill="#B9C4D8"
          />
        </svg>
      </div>
    </div>

    <div class="input__hint" v-if="hint">
      {{ translatedHint }}
    </div>
    <div class="input__errors" v-if="vErrors.length > 0">
      <div class="input__error">{{ vErrors[0].$message }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TextInput',
  props: {
    centered: {
      type: Boolean,
      default: false,
    },
    title: {
      type: [String, Number, Object],
      default: '',
    },
    placeholder: {
      type: [String, Object],
      default: '',
    },
		value: [String, Number],
    hint: {
      type: [String, Object],
      default: null,
    },
    type: {
      type: String,
      default: 'text',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    vErrors: {
      type: Array,
      default() {
        return []
      },
    },
    isError: {
      type: Boolean,
      default: false,
    },
    mask: {
      type: [String, Object, Function, Array],
      default: null,
    },
    withInformation: {
      type: Boolean,
      default: false,
    },
    passwordShow: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      default: 'base',
    },
    shouldTranslateTitle: {
      type: Boolean,
      default: false,
    },
    localizedTitle: {
      type: Boolean,
      default: false,
    },
    concentration: {
      type: Boolean,
      default: false,
    },
    numeric: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      text: '',
      isFocused: false,
      currentType: '',
      showFullTitle: false,
      windowWidth: window.innerWidth,
    }
  },
  created() {
		this.text = this.value === 0 ? this.value : this.value || ''
    this.currentType = this.type
  },
  mounted() {
    this.$emit('canFocus', this)
    window.addEventListener('resize', this.handleResize)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize)
  },
  computed: {
    locale() {
      let lang = this.$i18n?.locale ?? 'en'
      return lang === 'ua' ? 'uk' : lang
    },
    translatedTitle() {
      if (this.shouldTranslateTitle) {
        return this.$t(this.title)
      }

      if (this.localizedTitle && typeof this.title === 'object') {
        return this.title[this.locale] ?? this.title['en'] ?? ''
      }

      return this.title
    },
    translatedPlaceholder() {
      if (this.shouldTranslateTitle) {
        return this.$t(this.placeholder)
      }

      if (this.localizedTitle) {
        return this.placeholder[this.locale] ?? this.placeholder['en'] ?? ''
      }

      return this.placeholder
    },
    translatedHint() {
      if (this.shouldTranslateTitle) {
        return this.$t(this.hint)
      }

      if (this.localizedTitle) {
        return this.hint[this.locale] ?? this.hint['en'] ?? ''
      }

      return this.hint
    },

    truncatedTitle() {
      return this.showFullTitle
        ? this.$t(this.title).uk
        : this.truncateTitle(this.$t(this.title).uk, 20)
    },
  },
  watch: {
		value: function () {
			this.text = this.value ?? ''
		},
    text: function () {
      const str = this.text != null ? String(this.text) : ''

      if (this.passwordShow) {
        this.text = str.toString().replaceAll(/[а-яА-Я\s\/]/gmu, '')
      }

      if (this.numeric) {
        this.text = str.replace(/[^0-9]/g, '')
      }
    },
  },
  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth
    },
    toggleTitle() {
      this.showFullTitle = !this.showFullTitle
    },

    truncateTitle(text, length) {
      if (text !== undefined) {
        if (text.length <= length) {
          return text
        } else {
          return text.substring(0, length) + '...'
        }
      } else {
        return text
      }
    },

    checkAnimation(e) {
      if (e.animationName === 'onAutoFillStart') {
        this.text = this.text + ' '
        this.autofilled = true
      } else if (e.animationName === 'onAutoFillCancel') {
        this.text = this.text + ' '
        this.autofilled = false
      }
    },

    processFocus() {
			this.$emit('focus')
			this.$emit('textInputFocus')
      this.isFocused = true
    },
    processBlur() {
			this.$emit('textInputBlur')
      this.isFocused = false
    },
    processInput() {
			this.$emit('update:value', this.text)
    },
    copyToClipboard() {
      if (!navigator.clipboard) {
        return
      }

      navigator.clipboard.writeText(this.text).then(
        () => {
					this.$emit('copied')
        },
        (err) => {
          console.error('Async: Could not copy text: ', err)
        }
      )
    },
    focus() {
      this.$refs.inputEl.focus()
    },
    togglePasswordShow() {
      this.currentType = this.currentType === 'password' ? 'text' : 'password'
    },
    emitFocus() {
			this.$emit('focus')
    },
    emitFocusOut() {
			this.$emit('focusout')
    },
    emitEnter() {
			this.$emit('enter', this.text)
    },
  },
	emits: [
		'input',
		'update:value',
		'canFocus',
		'enter',
		'focus',
		'textInputFocus',
		'textInputBlur',
		'copied',
		'focusout',
	],
}
</script>

<style lang="scss" scoped>
.password-show {
  position: absolute;
  top: 50%;
  right: 18px;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
}
.input {
  width: 100%;
  position: relative;
  &.error & {
    &__el {
      border-color: #dd6262;
    }
  }

  &--small & {
    &__el {
      padding: 6px 16px 6px 12px;
      font-weight: 500;
      font-size: 12px;
      line-height: 28px;
      color: #47475e;
      opacity: 0.7;
      background: #fafcfe;
      border: 1px solid #f0f3fa;
      border-radius: 6px;
    }
  }

  &--filter & {
    &__el {
      padding: 13px 58px 13px 21px;
      height: auto;
      border: 1px solid #f2f4f7;
      border-radius: 8px;
      box-shadow: unset;
      font-weight: 400;
      font-size: 12px;
      line-height: 15px;
      color: #666d79;
      position: relative;
      cursor: default;
    }

    &__title {
      position: relative;
      top: 0;
      left: 0;
      font-weight: 300;
      font-size: 11px;
      line-height: 13px;
      color: #909cb0;
      padding: 0 0 0 10px;
      margin-bottom: 5px;
      max-width: 100%;
      transform: unset;
    }
  }

  &.centered & {
    &__el {
      text-align: center;
    }
  }

  &.with-information & {
    &__title {
      display: flex;
      align-items: center;
      padding: 2px 16px;
      background: #ffffff;
      border: 1px solid #f2f4f8;
      border-radius: 4px;
    }

    &__el {
      background: #f2f4f8 !important;
      border: 1px solid #f2f4f8 !important;
      color: #64748B !important;
    }

    &__information {
      display: flex;
      align-items: center;
      justify-content: center;

      &-icon {
        width: 19px;
        height: 19px;

        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 10px;
        cursor: pointer;
      }
    }
  }

  &.password-show-state & {
    &__el {
      padding-right: 40px;
    }
  }

  &__wrapper {
    position: relative;
    width: 100%;
  }

  &__title {
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    color: #465a8b;
    padding: 2px 10px;
    position: absolute;
    top: 0;
    left: 15px;
    max-width: calc(100% - 50px);

    transform: translateY(-50%);
    background-color: #fff;
  }

  &__el {
    background-color: transparent;
    border: 1px solid #e0e6f2;
    border-radius: 6px;
    color: #585f6d;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    outline: none;
    padding: 24px 15px 24px 21px;
    width: 100%;

    &:focus,
    &:active {
      border-color: #64748B;
    }

    &:disabled {
      border-color: #eee;
      color: #d0d9ea;
    }
  }

  &__hint {
    margin-top: 4px;
    font-weight: 500;
    font-size: 10px;
    line-height: 14px;
    color: #b9c4d8;
  }
}
</style>

<style>
:-webkit-autofill {
  animation-name: onAutoFillStart;
}
:not(:-webkit-autofill) {
  animation-name: onAutoFillCancel;
}
@keyframes onAutoFillStart {
  from {
  }
  to {
  }
}
@keyframes onAutoFillCancel {
  from {
  }
  to {
  }
}
</style>
